import { CustomFieldPrivacyOptions } from '@tribeplatform/gql-client/types'
import { Form } from '@tribeplatform/react-sdk/components'
import {
  useAuthMember,
  useAuthToken,
  useUpdateMember,
} from '@tribeplatform/react-sdk/hooks'
import { Accordion } from '@tribeplatform/react-ui-kit/Accordion'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Modal } from '@tribeplatform/react-ui-kit/Modal'

import { FieldInput } from '../CustomField/FieldInput'
import { getFieldSetting } from '../CustomField/utils'
import { ProfilePicture } from './ProfilePicture'

export const ProfileSettingsModal = ({ member, open, onClose }) => {
  const { mutateAsync: updateMember, isLoading } = useUpdateMember()
  const {
    data: { network },
  } = useAuthToken()
  const { isAdmin } = useAuthMember()

  const memberFields = {}
  member?.fields?.forEach(field => {
    memberFields[field.key] = JSON.parse(field.value)
  })
  const defaultValues = {
    ...member,
    ...memberFields,
  }

  const onSubmit = async data => {
    const { name, tagline, ...fields } = data

    const input = {
      name,
      tagline,
      fields: [],
    }

    network?.memberFields?.fields?.forEach(({ key }) => {
      if (fields[key] !== null && typeof fields[key] !== 'undefined') {
        input.fields.push({
          key,
          value: JSON.stringify(fields[key] === '' ? null : fields[key]),
        })
      }
    })

    return updateMember({
      id: member?.id,
      input,
    }).then(() => {
      onClose()
    })
  }

  const groupedFields =
    network?.memberFields?.fields?.reduce((groups, cur) => {
      const section = getFieldSetting(cur, 'section') || ''
      if (!groups[section]) groups[section] = []
      groups[section].push(cur)
      return groups
    }, {}) || {}

  return (
    <Modal open={open} onClose={onClose} size="xl">
      <Modal.Header title="Edit profile" />
      <Modal.Content>
        <Form
          defaultValues={defaultValues}
          onSubmit={onSubmit}
          className="flex flex-col space-y-5"
        >
          <div className="flex flex-col space-y-3">
            <div className="mx-auto mb-5">
              <ProfilePicture member={member} />
            </div>
            <div className="grid grid-cols-1 gap-5">
              <Form.Input name="name" label="Name" placeholder="John Smith" />
              <Form.Input
                name="tagline"
                label="Tagline"
                placeholder="CEO at Acme"
              />
              {Object.keys(groupedFields)
                ?.sort((a, b) => {
                  return a > b ? 1 : -1
                })
                .map(sectionName => {
                  const fields = groupedFields[sectionName]
                  const inputs = fields?.map(field => {
                    if (field?.archived) return null
                    if (
                      !isAdmin &&
                      field?.writePrivacy?.allow &&
                      field?.writePrivacy?.allow?.indexOf(
                        CustomFieldPrivacyOptions.OWN,
                      ) === -1
                    )
                      return null

                    const placeholder = getFieldSetting(field, 'placeholder')
                    const helperText = getFieldSetting(field, 'helperText')

                    return (
                      <FieldInput
                        key={field.key}
                        field={field}
                        label={field.name}
                        helperText={helperText}
                        placeholder={placeholder}
                      />
                    )
                  })

                  if (sectionName) {
                    return (
                      <Accordion>
                        <Accordion.Button>{sectionName}</Accordion.Button>
                        <Accordion.Panel className="flex-1 grid grid-cols-1 gap-5">
                          {inputs}
                        </Accordion.Panel>
                      </Accordion>
                    )
                  }
                  return <>{inputs}</>
                })}
            </div>
          </div>
          <Form.Actions className="pt-3">
            <Button type="submit" loading={isLoading} size="lg">
              Update
            </Button>
            <Button
              variant="outline"
              onClick={() => {
                onClose()
              }}
              size="lg"
            >
              Cancel
            </Button>
          </Form.Actions>
        </Form>
      </Modal.Content>
    </Modal>
  )
}
